import { ChangeDetectorRef, Directive, ElementRef, Input, NgZone, OnInit, Renderer2 } from '@angular/core'
import { fromEvent } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { filter, map, startWith, take } from 'rxjs/operators'

@UntilDestroy()
@Directive({
    selector: '[mgClassWhenInViewport]',
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class ClassWhenInViewport implements OnInit {
    @Input()
    mgClassWhenInViewport: string = ''

    constructor(
        private changeDetection: ChangeDetectorRef,
        public elementRef: ElementRef,
        private _zone: NgZone,
        private renderer2: Renderer2
    ) {}

    ngOnInit(): void {
        this._zone.runOutsideAngular(() => {
            this.registerScrollListener()
        })
    }

    private registerScrollListener() {
        fromEvent(window, 'scroll')
            .pipe(
                untilDestroyed(this),
                startWith(''),
                map(() => {
                    if (typeof this.elementRef.nativeElement.getBoundingClientRect === 'function') {
                        const viewportTop = this.elementRef.nativeElement.getBoundingClientRect().top
                        const clientTop = this.elementRef.nativeElement.clientTop

                        // get vertical position for selected element
                        return viewportTop + window.pageYOffset - clientTop
                    }
                    return 0
                }),
                filter(elementOffsetTop => window.pageYOffset + window.innerHeight > elementOffsetTop + 20),
                take(1)
            )
            .subscribe(() => {
                for (const className of this.mgClassWhenInViewport.split(' ')) {
                    this.renderer2.addClass(this.elementRef.nativeElement, className)
                }
            })
    }
}
